module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-04-4389f9290e38d9d59558f9ace088681f.svg";